// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xMdZ","question":"styles_question__3zDaR","description":"styles_description__2ODjw"};